import { Injectable } from '@wikia/dependency-injection';
import { DataWarehouseTracker } from '../data-warehouse';
import { trackingUrls } from '../tracking-urls';
import { utils } from '@ad-engine/core';

/**
 * Wrapper for labrador info warehouse trackingParams
 */
@Injectable()
export class LabradorTracker {
	constructor(private dwTracker: DataWarehouseTracker) {}

	/**
	 * Track labrador info values
	 */
	track(value: string): void {
		const now = new Date();
		// eliminates dev records from fact_adenglabradorinfo_events table
		const trackingUrl =
			window?.ads?.context?.env === 'dev'
				? trackingUrls.AD_ENG_DEV_LABRADOR_INFO
				: trackingUrls.AD_ENG_LABRADOR_INFO;

		this.dwTracker.track(
			{
				prop_value: value,
				timestamp: now.getTime(),
				tz_offset: now.getTimezoneOffset(),
				country: (utils.getCountryCode() || '').toUpperCase(),
			},
			trackingUrl,
		);
	}
}
